/**
 * presentationThemesApi — the theme catalog for the Export modal.
 *
 * Toggle via REACT_APP_PRESENTATION_THEMES_API env flag:
 *   unset / "live" → real HTTP calls
 *   "mock"         → offline fixture from presentationThemesApi.mock.ts
 */
import { isMockApiFlag } from "../apiMode";
import { API_ENDPOINTS, apiService } from "../api";
import { mockFetchPresentationThemes } from "./presentationThemesApi.mock";
import type { PresentationThemeListApi } from "./presentationThemes.types";

const isMock = (): boolean =>
  isMockApiFlag(process.env.REACT_APP_PRESENTATION_THEMES_API);

export async function fetchPresentationThemes(): Promise<PresentationThemeListApi> {
  if (isMock()) return mockFetchPresentationThemes();
  return apiService.get<PresentationThemeListApi>(API_ENDPOINTS.presentationThemes.list);
}
